<template>
  <el-button
    :type="btntype"
    :size="size"
    :disabled="disabled"
    :class="className"
    :round="round"
    :plain="plain"
    :circle="circle"
    :autofocus="autofocus"
    :icon="iconName"
    :native-type="nativeType"
    :loading="loading"
    @click="handleClick"
  >
    {{ title }}
    <slot></slot>
  </el-button>
</template>
<script>
export default {
  name: "butn",
  // 接受父组件的值
  props: {
    btntype: {
      //type	类型	string	primary / success / warning / danger / info / text
      type: String,
      default: ""
    },
    title: {
      //按钮Name
      type: String,
      default: "Button"
    },
    size: {
      //尺寸	string	medium / small / mini
      type: String,
      default: "small"
    },
    disabled: {
      //是否禁用状态	boolean
      type: Boolean,
      default: false
    },
    round: {
      //圆角
      type: Boolean,
      default: false
    },
    plain: {
      //朴素
      type: Boolean,
      default: false
    },
    circle: {
      //是否圆形按钮
      type: Boolean,
      default: false
    },
    loading: {
      //是否加载中状态
      type: Boolean,
      default: false
    },
    autofocus: {
      //是否默认聚焦	boolean
      type: Boolean,
      default: false
    },
    nativeType: {
      //原生 type 属性	string	button / submit / reset
      type: String,
      default: "button"
    },
    iconName: {
      //icon	图标类名	string
      type: String,
      default: ""
    },
    className: {
      //class
      type: String,
      default: ""
    },
    perms: {
      // 按钮权限标识，外部使用者传入
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClick: function() {
      // 按钮操作处理函数
      this.$emit("click", {});
    },
    has: function(perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return perms;
    }
  }
};
</script>
